export default __webpack_public_path__ + "static/media/default.426c87b3b6001296dd6a5592270105ce.png";